import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";
import Text from "components/atoms/Text";
import Icon from "components/atoms/Icon";
import { NhisTransactionStatus } from "types/nhis";
import NhisRequestStatusItem from "./NhisRequestStatusItem";

interface NhisRequestStatusListProps {
  requests: NhisTransactionStatus[];
  onCancelRequest?: (transactionId: string) => void;
  variant?: "default" | "compact";
  onItemClick?: (request: NhisTransactionStatus) => void;
  hideHeader?: boolean;
}

const Container = styled.div<{ $compact: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ $compact }) =>
    $compact
      ? ""
      : `
    margin-bottom: 16px;
    padding: 12px;
    border: 1px solid ${COLOR_SYSTEM.get("Blue")?.[100]};
    border-radius: 8px;
    background: ${COLOR_SYSTEM.get("Gray")?.[0]};
  `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

const NhisRequestStatusList: React.FC<NhisRequestStatusListProps> = ({
  requests,
  onCancelRequest,
  variant = "default",
  onItemClick,
  hideHeader = false,
}) => {
  if (!requests || requests.length === 0) return null;

  const isCompact = variant === "compact";

  return (
    <Container $compact={isCompact}>
      {!hideHeader && !isCompact && (
        <Header>
          <Icon name="Document Search" color={COLOR_SYSTEM.get("Blue")?.[500]} size={16} />
          <Text textType="Body2Bold" color={COLOR_SYSTEM.get("Blue")?.[600]}>
            처방내역 조회 현황
          </Text>
        </Header>
      )}
      {requests.map((request) => (
        <NhisRequestStatusItem
          key={request.transactionId}
          request={request}
          onCancel={onCancelRequest}
          variant={variant}
          onClick={onItemClick ? () => onItemClick(request) : undefined}
        />
      ))}
    </Container>
  );
};

export default NhisRequestStatusList;
